import { IpotekaLinkButton } from '../../../components/QuizCompleted';
import { HomeLinkButton } from '../../../components/QuizPersonalApplication/components/HomeLinkButton/HomeLinkButton';

export const extraBtnsMap = {
  mortgage: IpotekaLinkButton,
  mainPage: HomeLinkButton,
};
